export enum ViewLinkBlock {
  Root = 'ViewLink',
}

export enum ViewLinkModifier {
  Loading = 'loading',
  LinkStyle = 'linkStyle',
}
